"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateRange = void 0;
const dayjs = require("dayjs");
const getDateRange = (start_date, number_of_nights) => {
    // return an array of all the dates in the range
    const dates = [];
    let date = dayjs(start_date);
    if (number_of_nights === 0) {
        return [start_date];
    }
    const end_date = dayjs(start_date).add(number_of_nights, "days");
    while (date.isBefore(end_date)) {
        dates.push(date.format("YYYY-MM-DD"));
        date = date.add(1, "day");
    }
    return dates;
};
exports.getDateRange = getDateRange;
